"use client";

import { T_DynamicFormProps } from "@/types/form.type";
import dynamic from "next/dynamic";
import React from "react";

// Added a loading state for better UX
const Form = dynamic<T_DynamicFormProps>(() => import("./index"), { 
    ssr: false,
    loading: () => <div>Loading...</div> 
});

const DynamicFormWrapper = (props: T_DynamicFormProps) => {
    return <Form {...props} />;
};

export default DynamicFormWrapper;